<template>
    <div>
        <p
            class="text-center paragraph"
            style="padding: 0px icon-customer-profil30px"
        >
            This RPQ has been filled to the best of my knowledge and I agree
            that this questionnaire only provides some indication of my risk
            profile, which may or may not exactly reflect my ability to take
            risk and/ or risk tolerance level. Moreover, JSIL has provided all
            the necessary advice about the Fund(s), under its management. I
            agree that any misleading or inaccurate information provided herein
            may give wrong outcome of the recommendation made. Further, JSIL
            will not be held liable for any financial consequences.
        </p>
        <div class="row justify-content-center">
            <b-button
                type="button"
                variant="primary"
                class="primary-add-btn"
                @click="onclick"
            >
                <span class="btn-text">I Agree</span>
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onclick() {
            this.$emit('checked')
        },
    },
}
</script>
<style scoped>
p {
    margin: 0;
    font-size: 16px;
    padding: 0px 20px;
}
.icon-tick-with-circle {
    color: green;
    font-size: 30px;
    cursor: pointer;
}
</style>
